import { Box, Flex } from '@chakra-ui/layout';
import { IconButton, useTheme } from '@chakra-ui/react';
import { withTranslation } from 'react-i18next';
import '../i18n';
import CanopyButton from '../canopy-ui-components/components/CanopyButton/CanopyButton';
import { useCurrentColors } from '../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import { BsExclamationTriangleFill } from 'react-icons/bs';
function ErrorWL({t}: {t: any}) {
    const currentColors = useCurrentColors();
    const theme = useTheme();
    return (
        <Flex
            width="100%"
            align="center"
            direction="column"
            backgroundImage={`url('${theme?.images?.loginBg}')`}
            backgroundPosition="center"
            backgroundSize="cover"
            backgroundRepeat="no-repeat">
            <Flex
                maxWidth={['318px', '384px', '470px', '470px', '470px']}
                width="100%"
                direction="column"
                boxShadow={`1px 2px 6px ${currentColors.boxShadow}`}
                backgroundColor={`${currentColors.componentBg}`}
                border={`1px solid ${currentColors.componentBorder}`}
                borderRadius="6px"
                align="center"
                m="0"
                mt="100px"
                mb="20px"
                px="25px"
                py="30px">
                <IconButton
                    background="transparent"
                    cursor="pointer"
                    border="none"
                    fontSize={"20px"}
                    icon={<BsExclamationTriangleFill size={'2em'}/>}
                    aria-label="warning"
                    backgroundColor="transparent"
                    color={currentColors.brand['300']}
                    variant="ghost"
                    className="error-icon"
                    ></IconButton>
                <Box
                    marginTop="20px"
                    fontSize="20px">
                    {t('wl-error')}
                </Box>
                <CanopyButton
                    mt="20px"
                    fontSize="12px"
                    variant="ghost"
                    borderRadius="0"
                    color={currentColors.brand['300']}
                    backgroundColor={currentColors.brand['950']}
                    onClick={() => window.location.reload()}>
                    {t('try-again')}
                </CanopyButton>            
            </Flex>
        </Flex>
    );
}

export default withTranslation('translations')(ErrorWL);
